<template>
  <div id="app">
    <keep-alive>
      <router-view class="view"></router-view>
    </keep-alive>
    <back-top></back-top>
  </div>
</template>

<script>
import BackTop from '@/components/modules/BackTop.vue';
export default {
  name: 'App',
  components: {
      BackTop,
  },
  mounted() {
      // 猎豹浏览器地址栏隐藏也会触发resize
      window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", (event) => {
          console.log(event);
          window.location.reload();
      }, false);
    },
}
</script>

<style>
@import '../static/scss/base.css';
</style>



// WEBPACK FOOTER //
// src/App.vue